export default "__VITE_ASSET__C33BWa8h__"